module.exports = __webpack_public_path__ + "static/media/pesquisa_sem_resultado.f3f78a1e.svg";